import { requestFunnel } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';

const getOptions = () => ({ headers: authenticationService.authHeader() });
export const checkIn = async () => {
  const response = await requestFunnel.post('debt/check-in', {}, getOptions());
  return response.data;
};
